import { render, staticRenderFns } from "./UserWorkSecurityEdit.vue?vue&type=template&id=84dee950"
import script from "./UserWorkSecurityEdit.js?vue&type=script&lang=js&external"
export * from "./UserWorkSecurityEdit.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports